import { buildCsv } from './downloadOriginCsv';
import {
  inventoryLeadColumns,
  inventoryMetricColumns,
} from './downloadReportCatalog';

export { buildCsv };

const INVENTORY_FILE_KINDS = {
  stock_summary: 'stock',
  damage: 'damage',
  expiries: 'expiries',
};

export const inventoryCsvFileName = (subtype, from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  const kind = INVENTORY_FILE_KINDS[subtype] || 'stock';
  return `inventory-${kind}-${safePart(from)}-to-${safePart(to)}.csv`;
};

export const inventoryCsvLeadCells = (row, subtype) =>
  inventoryLeadColumns(subtype).map(column => (row || {})[column] || '');

export const inventoryCsvMetricCells = (metrics, subtype) =>
  inventoryMetricColumns(subtype).map(column => (metrics || {})[column] ?? 0);
